import Vuex from 'vuex';

const state = {
	show: false,
	signIn: {
		hasError: false
	},
	forgotPassword: {
		show: false,
		hasError: false,
		showSuccessMessage: false
	}
};

const getters = {
  show: state => state.show,
	showForgotPassword: state => state.forgotPassword.show,
	forgotPasswordSuccess: state => state.forgotPassword.showSuccessMessage,
	hasSignInError: state => state.signIn.hasError,
	hasForgotPasswordError: state => state.forgotPassword.hasError,
};

const actions = {
  show: ({ state, commit }, show) => {
		if(!show) {
			commit('resetState');
		}
		commit('show', show);
  },
	toggle: ({ state, commit }) => {
		if(state.show) {
			commit('resetState');
			return;
		}
		commit('show', !state.show);
  },
	forgotPassword: ({ state, commit }, show) => {
		commit('forgotPassword', show);
  },
	submitSignIn: ({ state, commit }, form) => {
		if(!form) {
			commit('resetState');
			return;
		}
		if(!form.email.value || !form.password.value) {
			commit('signInError', true);
			return;
		} else if (state.signIn.hasError) {
			commit('signInError', false);
		}
		superagent.post(form.action).send({
			email: form.email.value,
			password: form.password.value,
			remember: form.remember.checked
		}).set('accept', 'json').end((err, res) => {
			if(!err) {
				commit('signInError', true);
				return;
			}
			commit('submitSignInSuccess');
		});
  },
	submitForgotPassword: ({ state, commit }, form) => {
		if(!form){
			commit('resetState');
			return;
		}
		if(!form.email.value) {
			commit('forgotPasswordError', true);
			return;
		} else if (state.forgotPassword.hasError) {
			commit('forgotPasswordError', false);
		}
		superagent.post(form.action).send({
			email: form.email.value,
		}).set('accept', 'json').end((err, res) => {
			if(!err) {
				commit('forgotPasswordError', true);
				return;
			}
			commit('submitForgotPasswordSuccess');
		});
  },
};

const mutations = {
	show: (state, show) => {
		state.show = show;
	},
	forgotPassword: (state, show) => {
		state.forgotPassword.show = show;
	},
	signInError: (state, hasError) => {
		state.signIn.hasError = hasError;
	},
	forgotPasswordError: (state, hasError) => {
		state.forgotPassword.hasError = hasError;
	},
	resetState: (state) => {
		state.show = false,
		state.signIn = {
			hasError: false
		};
		state.forgotPassword = {
			show: false,
			hasError: false,
			showSuccessMessage: false
		};
	},
	submitSignInSuccess: (state) => {
		location.reload();
	},
	submitForgotPasswordSuccess: (state) => {
		state.forgotPassword.showSuccessMessage = true;
	}
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ../shared/store/modules/signin.js